import { useState } from 'react';

const useProfileDetails = () => {
  const [profileDetailsForm, setProfileDetailsForm] = useState({
    display_name: '',
    shipping_method_id: '',
    package_type: '',
    payment_method_id: '',
    signature_requirement: '',
    category: '',
  });

  const [packagingProperties, setPackagingProperties] = useState({
    dangerous_goods: false,
    includes_return_label: false,
    enabled: false,
    internal_use_only: false,
  });

  const [formErrors, setFormErrors] = useState<
    Partial<typeof profileDetailsForm>
  >({});

  const onValidate = () => {
    const errors: Partial<Partial<typeof profileDetailsForm>> = {};

    if (!profileDetailsForm.display_name) {
      errors.display_name = 'Display Name is required';
    }

    if (!profileDetailsForm.signature_requirement) {
      errors.signature_requirement = 'Signature Requirement is required';
    }

    if (!profileDetailsForm.shipping_method_id) {
      errors.shipping_method_id = 'Shipping Method is required';
    }

    setFormErrors(errors);

    return Object.keys(errors).length === 0;
  };

  return {
    profileDetailsForm,
    packagingProperties,
    formErrors,
    setProfileDetailsForm,
    setPackagingProperties,
    onValidate,
  };
};

export default useProfileDetails;
